import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Sidebar from './Sidebar';
import { Loader2 } from 'lucide-react';

const AppLayout = () => {
  const { loading, signOut } = useAuth();
  const navigate = useNavigate();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-blue-600" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 flex">
      <Sidebar onSignOut={signOut} />
      <main className="flex-1 ml-20 min-h-screen p-8">
        <Outlet />
      </main>
    </div>
  );
};

export default AppLayout;